"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stytchValidatePhone = exports.STYTCH_VALIDATION_WRONG_PHONE_MESSAGE = exports.stytchValidateLastName = exports.STYTCH_VALIDATION_WRONG_LAST_NAME_MESSAGE = exports.stytchValidateName = exports.STYTCH_VALIDATION_WRONG_FIRST_NAME_MESSAGE = exports.stytchValidateEmail = exports.STYTCH_VALIDATION_WRONG_EMAIL_MESSAGE = void 0;
exports.STYTCH_VALIDATION_WRONG_EMAIL_MESSAGE = 'Provide a valid email address';
const stytchValidateEmail = (email) => {
    const filter = /[a-z0-9!#$%&'*+/=?^_‘{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_‘{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i;
    return filter.test(email);
};
exports.stytchValidateEmail = stytchValidateEmail;
exports.STYTCH_VALIDATION_WRONG_FIRST_NAME_MESSAGE = 'First name must not be empty';
function stytchValidateName(name) {
    return name.trim().length > 0;
}
exports.stytchValidateName = stytchValidateName;
exports.STYTCH_VALIDATION_WRONG_LAST_NAME_MESSAGE = 'Last name must not be empty';
function stytchValidateLastName(name) {
    return name.trim().length > 0;
}
exports.stytchValidateLastName = stytchValidateLastName;
exports.STYTCH_VALIDATION_WRONG_PHONE_MESSAGE = 'Provide a valid phone number';
const stytchValidatePhone = (phone) => {
    const filter = /^\+[1-9]\d{1,14}$/g;
    return filter.test(phone);
};
exports.stytchValidatePhone = stytchValidatePhone;
